{"id":"Modal.Description","prefabs":{"default":{"children":[{"component":"Modal.Description","options":"options:*"}]}}}